<template>
  <div 
    class="main-content"
    :style="{ 
      '--sidebar-width': sidebarWidth,
      '--margin-top': isTotemAccessibility ? marginTopAccessibility : marginTop,
      '--margin-top-content': isTotemAccessibility ? marginTopAccessibilityContent : marginTopContent,
      '--margin-bottom': isTotemAccessibility ? marginBottom : '0px',
    }"
  >
    <div
      class="content-header"
      :style="{ 
        '--bg-header': menu && !menu.IsMenuWithSubmenu ? bgColor : 'white',
        '--color-header': menu && !menu.IsMenuWithSubmenu ? color : 'white',
      }"
    >
      <center v-if="menu">{{ getTranslation(menu.Name) }}</center>
    </div>
    <div
      class="content"
    >
      <div v-if="desktopView">
        <v-layout
          wrap
          v-for="(row, indexRows) in desktopView"
          :key="`rows${indexRows}`"
        >
          <v-flex
            v-for="(column, indexColumn) in row.Columns"
            :key="`column${indexColumn}`"
            v-bind="{ [column.Type]: true }"
          >
            <div 
              v-for="item in column.Contents"
              :key="`content${item.ID}`"
            >
              <items
                v-if="item.HideTotem !== 1"
                :item="item"
                :menuID="menu.ID"
                :isMobile="false"
                :columnType="column.Type"
              /> 
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-else
        v-for="item in apiContents"
        :key="`content${item.ID}`"
      >
        <items
          :item="item"
          :menuID="menu.ID"
          :isMobile="false"
        />
      </div>
      <!-- <div v-if="apiContents">
        <div 
          v-for="item in apiContents"
          :key="`content${item.ID}`"
        >
          <items
            :item="item"
            :menuID="id"
            :isMobile="false"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import constants from '@/constants'
import i18n from '@/plugins/i18n'
import Items from '@/components/Items.vue'
import dview from '@/services/dview-service'
export default {
  components: {
    Items
  },
  props: {
    enterprise: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    desktopView: null,
    apiContents: null,
    menu: null,
    bgColor: 'white',
    color: 'white'
  }),
  computed: {
    ...mapState('app',['isTotemAccessibility', 'totemMenuSelected']),
    locale () {
      return i18n.locale
    },
    sidebarWidth() {
      return constants.totem.sidebar.width + 'px'
    },
    marginTopAccessibility() {
      return constants.totem.messages.height + 'px'
    },
    marginTop() {
      return (constants.totem.meteo.height + constants.totem.messages.height) + 'px'
    },
    marginBottom() {
      return constants.totem.mainMenu.height + 'px'
    },
    marginTopAccessibilityContent() {
      return (constants.totem.messages.height + 70) + 'px'
    },
    marginTopContent() {
      return (constants.totem.meteo.height + constants.totem.messages.height + 70) + 'px'
    },
  },
  watch: {
    totemMenuSelected: {
      handler: function (newValue) {
        if (newValue && newValue.ID) this.getContent(newValue.ID)
        this.menu = newValue
        // this.bgColor = newValue.ParentID ? this.enterprise.BGColorSecundary : this.enterprise.BGColor
        // this.color = newValue.ParentID ? this.enterprise.ColorSecundary : this.enterprise.Color
        this.bgColor = this.enterprise.BGColorSecundary
        this.color = this.enterprise.ColorSecundary
      },
      deep: true
    },
  },
  methods: {
    getTranslation(value) {
      return utils.getTranslation(value, this.locale)
    },
    // getContent(id) {
    //   api.getAll(`contents`, false, null, null, null, id).then(response => {
    //     this.apiContents = response 
    //   })
    // }
    getContent(id) {
      api.getAll(`contents`, false, null, null, null, id).then(response => {
        // this.apiContents = response
          this.apiContents = response.map(item => {
            item.IsActive = dview.isActive(item)
            return (item)
          }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation)

        api.getAll(`menus/desktop-view`, false, null, null, null, id).then(responseDesktopView => {
          let rdv = JSON.parse(responseDesktopView.struct)
          if (rdv) {
            const ids = []
            for (let i = 0; i < rdv.length; i++) {
                for (let j = 0; j < rdv[i].Columns.length; j++) {
                  rdv[i].Columns[j].Contents = rdv[i].Columns[j].Contents
                  for (let k = 0; k < rdv[i].Columns[j].Contents.length; k++) {
                    rdv[i].Columns[j].Contents[k] = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID) [0]
                    ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                  } 
                } 
              }
            // for (let item of rdv) {
            //   for (let column of item.Columns) {
            //     for (let content of column.Contents.filter(x => x.HideTotem !== true)) {
            //       content = this.apiContents.filter(x => x.ID === content.ID) [0]
            //       ids.push(content.ID) // utilizado para obtener los ids del contenido configurado
            //     } 
            //   } 
            // }
            // Añadimos al una fila al final para todo el contenido no actualizado

            rdv.push({
              Columns: [
                {
                  Type: 'xs12',
                  Contents: this.apiContents.filter(x => ids.indexOf(x.ID) < 0)
                }
              ]
            })
          }
          this.desktopView = rdv
        })
        // api.getAll(`contents`, false, null, null, null, id).then(response => {
        //   this.apiContents = response 
        // })
      })
    }
  }
}
</script>

<style>
  .main-content {
    position: fixed;
    top: var(--margin-top);
    left: var(--sidebar-width);
    right: 20px;
    border-radius: 10px 10px 0 0;
    bottom: var(--margin-bottom);
    overflow-x: scroll;
  }
  .content-header {
    padding:20px;
    background-color: var(--bg-header);
    border-radius: 10px 10px 0 0;
    color: var(--color-header);
    font-size: 20px;
    font-weight: 700;
    height: 70px;
  }
  .content {
    background-color: white;
    position: fixed;
    top: var(--margin-top-content);
    left: var(--sidebar-width);
    right: 20px;
    bottom: var(--margin-bottom);
    overflow-x: scroll;
  }
</style>